import styled, { css } from 'styled-components';

import type { IMailSubscriptionTheme } from '@/shared/themes/types';

export const Wrapper = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    background-color: ${theme.defaultPrimaryColor};
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: 5px 10px;
    text-align: center;
  `}
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  color: #ffffff;
  margin: 0;
  padding-right: 25px;
  margin-bottom: 5px;
`;
export const Description = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  margin: 0;
`;
